<template>

  <div class="modal_body">        
    <div class="view_wrap">
      <dl>
        <dt>수행일정</dt>
        <dd>{{scheduleDateInfo}}</dd>
      </dl>
      <dl>
        <dt>수행시간</dt>
        <dd>{{scheduleTimeInfo}}</dd>
      </dl>
      <dl>
        <dt>제외일자</dt>
        <dd>{{excludeOptions}}</dd>
      </dl>
      <dl>
        <dt>발신번호 </dt>
        <dd>{{callerIdInfo}}</dd>
      </dl>
      <dl>
        <dt>{{this.$i18n.t('MSG_TXT_SCENARIO')}}</dt>
        <dd>{{scenarioName}}</dd>
      </dl>
      <dl>
        <dt>수신리스트</dt>
        <dd>{{calleeCountInfo}}  
          <ur-button shape="hyperlink" primary @click="onClickCalleePopup" v-if="showCalleeInfo">상세보기</ur-button>
          <ur-button shape="hyperlink" primary @click="onClickDownload" v-if="showCalleeInfo">파일 다운로드</ur-button>
          <div class="info_wrap" v-if="showCalleeInfo === false">
              <ur-icon type="line" id="home">information</ur-icon>
              <ur-tooltip target-id="home" bottom mouse-over>
                <div class="tooltip multi">
                  <ul class="progress_bar_state">
                    <li class="p1">개인정보보호를 위해 완료/취소 후 7일 경과한 수신리스트는 조회할 수 없습니다.</li>
                  </ul>
                </div>
              </ur-tooltip>
          </div>
        </dd>
      </dl>
      <dl>
        <dt>콜 시도</dt>
        <dd><strong>{{callRetryCountInfo}}</strong>{{callRetryDescription}}</dd>
      </dl>
      <dl class="full">
        <dt>{{this.$i18n.t('MSG_TXT_DETAIL_CNTN')}}</dt>
        <dd>{{scheduleDescription}}</dd>
      </dl>
      <div class="campaign_info">
          <p class="name"><strong>최초 작성</strong>{{registerInfo}}</p>
          <p class="date">|</p>
          <p class="name"><strong>최근 수정</strong>{{modifyInfo}}</p>
      </div>  

    </div>

    <!-- <callee-detail-popup :calleeInfoList="calleeInfoListProps" :scenarioVariables="scenarioVariablesProps" :outCallSchedule="outCallSchedule" 
        ref="calleeDetailModal"/> -->

    <!-- Csv 다운로드용 hidden data grid -->
    <div class="data_tbl_list" hidden>
      <ur-data-grid :headers="calleeHeaders" :data-source="calleeItems" ref="csvGrid" />
    </div>

  </div>
  
</template>

<script>
import BasePage from '~cm/components/BasePage';
// import calleeDetailPopup from './PGE_AIC_00004_P02';

export default {
  name: 'PGE_AIC_00004_T01', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  components: {
    BasePage,
    // calleeDetailPopup,
  }, 

  props: {
    outCallSchedule: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      calleeInfoList: [],

      calleeHeadersBase : [
        {value:'calleeNumber', text: this.$t('MSG_TXT_CALLEE_NUMBER1'), width: 200, key:true, sort: true, filter:true},
        {value:'reservationDate', text: this.$t('MSG_TXT_RESERVATION_DATE'), width: 100, sort: true, filter:true},
        {value:'reservationTime', text: this.$t('MSG_TXT_RESERVATION_TIME'), width: 100, sort: true, filter:true},
        {value:'runScriptOrder', text: '대화ID 순서', width: 200, sort: true, filter:true},
        {value:'customerId', text: '고객ID', width: 200, sort: true, filter:true},
      ],
      calleeHeaders: [],
      calleeItems: [],
      calleeItemsCsv: [],

      calleeCustomColumns: [],
    };    
  },
 
  computed: {
    registerInfo() {
      return this.getRegisterInfo(this.outCallSchedule);
    },

    modifyInfo() {
      return this.getModifyInfo(this.outCallSchedule);
    },

    scheduleStatusInfo() {
      let statusName = '';
      if (this.outCallSchedule.scheduleStatus) {
        statusName = aiccCode.scheduleStatus.codeText(this.outCallSchedule.scheduleStatus);
      }      
      return statusName;
    },

    scheduleDateInfo() {
      return this.getScheduleDateInfo(this.outCallSchedule);
    },
    
    scheduleTimeInfo() {
      return this.outCallSchedule.startTimeLimit.substr(0,2) + ':' + this.outCallSchedule.startTimeLimit.substr(2,2) + " ~ " + 
             this.outCallSchedule.endTimeLimit.substr(0,2) + ':' + this.outCallSchedule.endTimeLimit.substr(2,2);
    },

    excludeOptions() {
      let excludeSaturday = this.getExcludeSaturday(this.outCallSchedule);
      let excludeSundayHoliday = this.getExcludeSundayHoliday(this.outCallSchedule);
      if (excludeSaturday === 'Y' && excludeSundayHoliday === 'Y') {
        return '토요일, 일요일, 공휴일 제외';
      } else if (excludeSaturday === 'Y') {
        return '토요일 제외';
      } else if (excludeSundayHoliday === 'Y') {
        return '일요일, 공휴일 제외';
      } else {
        return '-';
      }
    },

    callerIdInfo() {
      return this.getCallerIdInfo(this.outCallSchedule);
    },

    showCalleeInfo() {
        // 완료(D), 취소(F) 캠페인의 경우 최종 수정일자 이후 7일 경과시 상세보기/파일다운로드 미제공 
        // console.log('this.outCallSchedule.scheduleStatus', this.outCallSchedule.scheduleStatus)
        // if (this.outCallSchedule.scheduleStatus === 'D' || this.outCallSchedule.scheduleStatus === 'F') {
        //     let lastUpdateDate = utils.toStringByFormat(this.outCallSchedule.fnlMdfcDtm, 'YYYY-MM-DD');
        //     let currentDate = utils.now('YYYY-MM-DD');
        //     let pastDays = utils.getDayOffset(currentDate, lastUpdateDate); // getDayOffset(targetDate, diffDate)
        //     if (pastDays > 7) {
        //         return false;
        //     }
        // }
        return this.outCallSchedule.showCalleeInfo;
    },

    scenarioName() {
      return this.outCallSchedule.scenarioName;
    },

    callRetryCountInfo() {
      // retryCount는 retryNumber + 1 이다.
      // 콜 시도 횟수 1이라는 의미는 1번만 콜 하고 retry 하지 않는다는 의미로 retryNumber는 0 이기 때문이다.
      let retryCount = this.outCallSchedule.retryNumber + 1;
      return retryCount;
    },

    callRetryDescription() {
      let returnCallRetryDescription = '';
      let retryCount = this.outCallSchedule.retryNumber + 1;
      if (retryCount > 1) {
        returnCallRetryDescription = '회 (1회차 완료 후 재시도)';
      } else {
        returnCallRetryDescription = '회';
      }
      return returnCallRetryDescription;
    },

    calleeCountInfo() {
      return utils.numberFormat(this.outCallSchedule.calleeCount) + "건";
    },

    scheduleDescription() {
      if (!utils.isEmpty(this.outCallSchedule.scheduleDescription)) {
        return this.outCallSchedule.scheduleDescription;  
      }
      return '-';
    },
    
    userNm() {
      return this.outCallSchedule.userNm;
    },

    calleeInfoListProps() {
      let result = [];
      for(let index in this.outCallSchedule.calleeInfoList) {
        result.push(this.outCallSchedule.calleeInfoList[index]);
      }
      return result;
    },

    scenarioVariablesProps() {
      let result = [];
      for(let index in this.outCallSchedule.scenarioVariables) {
        result.push(this.outCallSchedule.scenarioVariables[index]);
      }
      return result;
    }
  },
 
  watch: {

  },

  mounted() {
    this.calleeHeaders = this.calleeHeadersBase.slice();
  },
 
  methods: {
    onLoad() {

    },

    onClickCalleePopup() {
      // this.$refs['calleeDetailModal'].open();
      let scheduleId = this.outCallSchedule.scheduleId;
      // let parentPageId = this.contextPageId;
      let url = `/popup.html#/PGE_AIC_00015?scheduleId=${scheduleId}`;
      const newWindowOptions = 'width=1280,height=860,location=no,menubar=no,status=no,toolbar=no,resizable=no';
      const centerPopupOption = aiccUtils.popupUtil.getCenterPopupOption(newWindowOptions);
      let popupWin = window.open(window.location.pathname + url, '', centerPopupOption);
    },

    setCalleeList(calleeList) {
      this.outCallSchedule.calleeInfoList = calleeList;
      // this.outCallSchedule.calleeInfoList = [];
      // for(let index in calleeList) {
      //   this.outCallSchedule.calleeInfoList.push(calleeList[index]);
      // }
      this.setCalleeListForDownload();
    },

    getRegisterInfo(data) {
      let userNm = '-';
      if (data.userNm !== null && !utils.isEmpty(data.userNm)) {
        userNm = data.userNm;
      }
      if (!utils.isEmpty(data.fstRgstDtm)) {
        return userNm + " (" + utils.toStringByFormat(utils.toDate(data.fstRgstDtm), 'YYYY-MM-DD HH:mm')+ ")";
      } 
      return userNm + " (" + ' - '+ ")";
    },

    getModifyInfo(data) {
      let userNm = '-';
      if (data.fnlMdfcUsrNm !== null && !utils.isEmpty(data.fnlMdfcUsrNm)) {
        userNm = data.fnlMdfcUsrNm;
      }
      if (!utils.isEmpty(data.fnlMdfcDtm)) {
        return userNm + " (" + utils.toStringByFormat(utils.toDate(data.fnlMdfcDtm), 'YYYY-MM-DD HH:mm')+ ")";
      } 
      return userNm + " (" + ' - '+ ")";
    },

    getScheduleDateInfo(data) {
      return utils.toStringByFormat(utils.toDate(data.startDate), 'YYYY-MM-DD') + " ~ " +
             utils.toStringByFormat(utils.toDate(data.endDate), 'YYYY-MM-DD');
    },

    getExcludeSaturday(data) {
      let isExcludeSaturday = "N";
      if (!utils.isEmpty(data.excludeDayofweek)) {
        let excludeDayofweek = data.excludeDayofweek.split(',');
        for (var day of excludeDayofweek) {
          if (day === "7") {
            isExcludeSaturday = "Y";
          }
        }
      }
      return isExcludeSaturday;
    },

    getExcludeSundayHoliday(data) {
      let isExcludeSundayHoliday = "N";
      let excludeSunday = false;

      if (!utils.isEmpty(data.excludeDayofweek)) {
        let excludeDayofweek = data.excludeDayofweek.split(',');
        for (var day of excludeDayofweek) {
          if (day === "1") {
            excludeSunday = true;
          }
        }
      }
   
      let excludeHoliday = false;
      if (data.excludeHolidayYn === "Y") {
        excludeHoliday = true;
      }
      
      if (excludeSunday && excludeHoliday) {
        isExcludeSundayHoliday = "Y";
      }
      return isExcludeSundayHoliday;
    },

    getCallerIdInfo(data) {
      // 070-1234-5678 | 해피콜 #1 | 1588-9999 | 5채널 
      let callerIdInfo = '';
      let callerId = '-';
      if (!utils.isEmpty(data.callerId)) {
        callerId = data.callerId;
      }
      if (!utils.isEmpty(data.sipNumberDescription)) {
        callerIdInfo = data.sipNumber + " | " + data.sipNumberDescription + " | " + callerId + " | " + data.channels + " 채널";
      } else {
        callerIdInfo = data.sipNumber + " | " + callerId + " | " + data.channels + " 채널";
      }
      
      return callerIdInfo;
    },

    setCalleeListForDownload() {
      this.calleeHeaders = [];
      this.calleeHeaders = this.calleeHeadersBase.slice();
      this.calleeCustomColumns = [];
      if (!utils.isEmpty(this.outCallSchedule.scenarioVariables)) {
        for(let column of this.outCallSchedule.scenarioVariables) {
          this.calleeHeaders.push(column);
          this.calleeCustomColumns.push(column.value);
        }
      }

      // console.log('setCalleeListForDownload', this.calleeHeaders)

      this.calleeItemsCsv = [];
      for (var callee of this.outCallSchedule.calleeInfoList) {
        let row = {};
        // row.calleeNumber = callee.calleeNumber.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/,"$1-$2-$3");
        row.calleeNumber = callee.calleeNumber;
        if (!utils.isEmpty(callee.reservationDate)) {
          row.reservationDate = utils.toStringByFormat(utils.toDate(callee.reservationDate), 'YYYY-MM-DD')
        }  
        if (!utils.isEmpty(callee.reservationTime)) {
          row.reservationTime = callee.reservationTime.substr(0,2)+':'+callee.reservationTime.substr(2,2);
        }
        if (!utils.isEmpty(callee.outcallData)) {          
          let outcallData = JSON.parse(callee.outcallData);
          row.runScriptOrder = outcallData['__runScriptOrder'];
          utils.forEach(this.calleeCustomColumns, customColumns => {
            row[customColumns] = outcallData[customColumns]; 
          });
        }
        row.customerId = callee.customerId;
        this.calleeItemsCsv.push(row);
      }
      // console.log('setCalleeListForDownload', this.calleeItems)
    },
    
    onClickDownload() {
      const sCsvName =`AICC_SCHEDULE_CALLEELIST_${utils.now('YYYYMMDDHHmmss')}.csv`;
      const fileDownloadHistoryAsk = {
        pageId: this.contextPageId,
        fileName: sCsvName,
        fileDetail: `Campaign Id : ${this.outCallSchedule.scheduleId} / Campaign name : ${this.outCallSchedule.scheduleName}`,
      };      

      http.request(this.contextPageId, 'DTS_AIZ_00001', {
        data: fileDownloadHistoryAsk,
      }).then(res => {
        if (res.status === 200) {
          this.calleeItems = this.calleeItemsCsv;
          this.$nextTick( () => {
            this.onDownloadTableToCsv(this.calleeHeaders, sCsvName);
          });
        } else {
          utils.aiccMessageBox('알림', '잠시 후 다시 시도해주세요.', '확인', null);
        }
      }).catch(error => {
        console.warn(error);
      });

    },

    onDownloadTableToCsv(headerObj, csvFileNm) {
      var blob, csvUrl, a;
      var csvArray = [];
      // 1. set header
      csvArray.push(headerObj.map((f) => f.text));

      // 2. set Data
      var gridData = this.$refs.csvGrid.getViewData();
      csvArray = csvArray.concat(
        gridData.map((row) => {
          return headerObj.map((f) => {
            return row[f.value];
          });
        })
      );
      csvArray = aiccUtils.stringUtil.enclose2DArrayInDoubleQuotes(csvArray);
      const BOM = "\uFEFF";
      var csvString = BOM + csvArray.map((r) => r.join(",")).join("\r\n");
      blob = new Blob([csvString], { type: "text/csv;charset=utf8" });
      csvUrl = URL.createObjectURL(blob);
      a = document.createElement("a");
      a.setAttribute("style", "display:none");
      a.setAttribute("href", csvUrl);
      a.setAttribute("download", csvFileNm);
      document.body.appendChild(a);
      a.click();
      a.remove();
    },

    getTodayYmd() {
      return utils.now('YYYY-MM-DD');
    },

    generateRandomNmber(n) {
      let str = ''
      for (let i = 0; i < n; i++) {
        str += Math.floor(Math.random() * 10)
      }
      return str
    },

  },
  
};
</script>

<style scoped>
.ur-button--borderless.ur-button--primary, .ur-button--primary.ur-button--hyperlink{
  height: 24px;
}
</style>